export default {
    name: 'CheckmarkSmall',
    dimensions: { width: 14, height: 11 },
    content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round">
      <path d="M5 9.25L13 1.25"/>
      <path d="M1 5.25L5 9.25"/>
    </g>
  `
};
